import React, { Children } from 'react';
import cn from 'clsx';
import { bool, node, string } from 'prop-types';
import Icon from '../../atoms/Icon/index.jsx';

/**
 * IconStack component.
 */
const IconStack = ({
  children,
  srOnly,
  className,
  noAlign
}) => {
  const icons = Children.toArray(children);
  const sizes = icons.map(icon => icon.props.size || 1);
  const sizingUnits = icons.map(icon => icon.props.sizingUnit);
  const groupSize = Math.max(...sizes);
  if (new Set(sizingUnits).size > 1) {
    throw new TypeError(`Custom sizing units in an icon stack must all be set to the same value, got ${sizingUnits}`);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('icon-stack', className, !noAlign && 'icon-stack--vertical-align'),
    style: {
      height: `${groupSize}${sizingUnits[0]}`,
      width: `${groupSize}${sizingUnits[0]}`
    }
  }, srOnly && /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, srOnly), icons.map((icon, index) => /*#__PURE__*/React.createElement("div", {
    key: `${icon.props.name}-${icon.props.color}-${icon.props.size}`,
    className: "icon-stack__icon",
    style: {
      zIndex: icons.length - index
    }
  }, icon)));
};
IconStack.defaultProps = {
  srOnly: null,
  className: null,
  noAlign: false
};
IconStack.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The icons to be stacked. */
  children: node.isRequired,
  /** Hidden screen reader text. */
  srOnly: string,
  /** Additional class names to add to the component root. */
  className: string,
  /** Option to set whether the icon is vertically aligned */
  noAlign: bool
} : {};
IconStack.Icon = Icon;
export default IconStack;